module.exports = __webpack_public_path__ + "assets/sales-recruiters-near-me-5.582f8062.png";